import { useQuery } from "@tanstack/react-query";

import type { UseQueryResult } from "@tanstack/react-query";

import type { WorldMap } from "./charts.types";

async function loadWorldMap(): Promise<WorldMap> {
  const { WORLD_MAP } = await import("./worldMap.data");
  return WORLD_MAP;
}

export default function useWorldMap(): UseQueryResult<WorldMap> {
  return useQuery({
    queryKey: ["worldMap"],
    queryFn: loadWorldMap,
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: false,
  });
}
